<app-heading [title]="jobStatusTitle" [button]="headingButton" [showToggle]="false"></app-heading>
<div class="grid grid-nogutter">
    <div class="col-12 p-0 mb-4">
        <div class="grid grid-nogutter">
            <div class="col-12 md:col-6 xl:col-6 lg:col-6 sm:col-12 p-0">
                <div class="wrap-left">
                    <div class="grid grid-nogutter">
                        <div class="md:pr-1 sm:pr-0 col-12 md:col-4 sm:col-12 ">
                            <p-iconField iconPosition="right">
                                <p-inputIcon styleClass="pi pi-search cursor-pointer" (click)="getJobs($event)" />
                                <input (keydown)="onEnter($event)" [(ngModel)]="searchText" type="text" pInputText placeholder="Search jobs" [disabled]="isSearchDisabled()" />
                            </p-iconField>
                        </div>
                        
                        <!-- Enhanced Sort Section -->
                        <div class="my-2 md:my-0 md:pl-2 sm:pl-0 col-12 md:col-4 sm:col-12">
                            <div class="sort-container flex align-items-center gap-2">
                                <!-- <p-select 
                                    [ngModel]="selectedSortOption()"
                                    (onChange)="onSortOptionChange($event)" 
                                    [options]="sortOptions" 
                                    optionLabel="name"
                                    [placeholder]="'Sort By' | sentenceCase" 
                                    class="flex-1 sort-select">
                                </p-select> -->
                                
                                  <p-dropdown 
                                [(ngModel)]="selectedFilter" 
                                (onChange)="onFilterChange($event)" 
                                [options]="filters" 
                                optionLabel="name" 
                                (keydown)="onEnter($event)"
                                placeholder="Filter by" 
                                class="w-full"></p-dropdown>
                                <!-- Sort Direction Toggle Button -->
                                <p-button 
                                    [icon]="sortDirection === 'asc' ? 'pi pi-sort-alpha-up' : 'pi pi-sort-alpha-down'"
                                    [pTooltip]="sortDirection === 'asc' ? 'Oldest' : 'Newest'"
                                    tooltipPosition="top"
                                    (click)="toggleSortDirection()"
                                    [outlined]="true"
                                    size="small"
                                    styleClass="sort-direction-btn">
                                </p-button>
                            </div>
                            
                            <!-- Optional: Display current sort info -->
                            <small class="sort-info text-xs text-500 mt-1 block">
                                {{ sortDisplayText }}
                            </small>
                        </div>
                        
                        <div class="my-2 md:my-0 md:pl-2 sm:pl-0 col-12 md:col-4 sm:col-12">
                          
                        </div>
                        
                        <div class="col-12 mt-3" *ngIf="showRateFilters">
                            <div class="grid grid-nogutter">
                                <div class="col-12 mb-2">
                                    <label class="text-sm font-medium">Rate Options:</label>
                                </div>
                                <div class="col-12 md:col-6 mb-2" *ngFor="let option of rateFilterOptions">
                                    <p-checkbox 
                                        [(ngModel)]="selectedRateOptions" 
                                        [inputId]="option.value"
                                        [value]="option.value"
                                        (onChange)="onRateFilterChange()">
                                    </p-checkbox>
                                    <label [for]="option.value" class="ml-2 text-sm">{{ option.label }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="col-12 p-0">
        <div class="p-datatable-striped">
            <p-table 
            #dt
            [value]="jobs"
            styleClass="p-datatable-sm p-datatable-sm--normal"
            [tableStyle]="{ 'min-width': '60rem' }"
            [rows]="10"
            [paginator]="true"
            [totalRecords]="jobsCount"
            [lazy]="true"
            (onLazyLoad)="getJobs($event)"
            [showCurrentPageReport]="true" 
            currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
            autoLayout="true"
            [scrollable]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width:20%">Name</th>
                        <th style="width:18%">Start Date</th>
                        <th style="width:18%">Published At</th>
                        <th style="width:20%">Rate</th>
                        @if (helperService.checkResponsive()) {
                            <th alignFrozen="right" pFrozenColumn>
                              <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                            </th>
                            } @else {
                            <th style="width: 24%;">
                              <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                            </th>
                            }
                            <ng-template #frozenHeader>
                            Action
                            </ng-template>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-job>
                    <tr class="table-data cursor-pointer" (click)="goToJobDetails(job)">
                        <td>{{ job.title }}</td>
                        
                        <!-- Start Date Column -->
                        <td *ngIf="job.startDate">{{ job.startDate | date: 'MM/dd/yyyy' }}</td>
                        <td *ngIf="!job.startDate" class="text-muted">No start date</td>
                        
                        <!-- Published At Column -->
                        <td *ngIf="job.publishedAt && job.status === 'PUBLISHED'">{{ job.publishedAt | date: 'MM/dd/yyyy' }}</td>
                        <td *ngIf="job.status === 'UNPUBLISHED' || job.status === 'APPROVAL_PENDING' || job.status === 'DENIED'" class="text-muted">Not published</td>
                        <td *ngIf="job.status === 'ARCHIVED'" class="text-muted">Archived</td>
                        <td *ngIf="!(job.publishedAt && job.status === 'PUBLISHED') && job.status !== 'UNPUBLISHED' && job.status !== 'APPROVAL_PENDING' && job.status !== 'DENIED' && job.status !== 'ARCHIVED'" class="text-muted">-</td>
                        
                        <!-- Rate Column -->
                        <td *ngIf="job.rate && !job.rateRange?.rateMinimum">{{ job.rate }}{{job.rateOption=='hourly'?"/hour":"/year"}}</td>
                        <td *ngIf="job.rateRange && job.rateRange?.rateMinimum">${{ job.rateRange.rateMinimum }} - ${{ job.rateRange.rateMaximum }} {{job.rateOption=='hourly'?"/hour":"/year"}}</td>
                        <td *ngIf="!job.rate && job.rateOption === 'experience'">Depends On Experience</td>
                        <td *ngIf="job.rateOption === '' || job.rateOption === 'none'" class="text-muted">Not Specified</td>
                        
                        <!-- Actions Column -->
                        @if (helperService.checkResponsive()) {
                            <td alignFrozen="right" pFrozenColumn>
                              <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                            </td>
                            } @else {
                            <td>
                              <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                            </td>
                            } 
                            <ng-template #frozenData>
                                <div class="wrap-actions flex align-items-center gap-2">
                                    <div *ngIf="job.status !== 'ARCHIVED'">
                                        <p-button pTooltip="Edit" 
                                            tooltipPosition="top" [rounded]="true" [text]="true" icon="true" (click)="onEditJob($event,job)">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined">
                                            </span>
                                        </p-button>
                                        
                                        <p-button pTooltip="Archive" 
                                        tooltipPosition="top" [rounded]="true" [text]="true" icon="true" (click)="onArchiveJob($event,job)">
                                            <span class="{{helperService.getEnvironmentName()}}-icon icon-archive-outlined red">
                                            </span>
                                        </p-button>
                                    </div>
                                    <p-button *ngIf="job.status === 'UNPUBLISHED'" pTooltip="Publish" tooltipPosition="top" [rounded]="true" [text]="true" icon="true" (click)="onPublishJob($event,job)">
                                           <span class="{{helperService.getEnvironmentName()}}-icon icon-published-with-changes-outlined font-bold">
                                           </span>
                                    </p-button>
                                    <p-button *ngIf="job.status === 'ARCHIVED'" pTooltip="Restore job" 
                                    tooltipPosition="top" [rounded]="true" [text]="true" icon="true" (click)="onRestoreJob($event,job)">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-sync-outlined">
                                        </span>
                                    </p-button>
                                </div>
                            </ng-template>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
